import { type FC } from "react";

import styled from "@emotion/styled";
import { Skeleton } from "@snapchat/snap-design-system";

const Container = styled.div`
    display: flex;
    margin-top: 8px;
`;

export const ValueSkeleton: FC = () => (
    <Container>
        <Skeleton height={16} />
    </Container>
);
